import React from 'react'
import EmployerInformationForm from './EmployerInformationForm'
import { Formik, Form } from 'formik'
import effects from 'app/effects/effects'
import { employerMappingToApi } from '../mapping/profileMapping'
import { useDispatch } from 'react-redux'
import MessageAlert from 'app/components/MessageAlert'
import { useIntl } from 'react-intl'
import { useFormContext, TEXT_200_MAX } from '../FormProvider'
import * as Yup from 'yup'

const validationSchema = (formatMessage) => {
  return Yup.object({
    companyName: Yup.string().max(
      TEXT_200_MAX,
      formatMessage(
        { id: 'maximum.characters.allowed' },
        { limit: TEXT_200_MAX },
      ),
    ),
    jobTitle: Yup.string().max(
      TEXT_200_MAX,
      formatMessage(
        { id: 'maximum.characters.allowed' },
        { limit: TEXT_200_MAX },
      ),
    ),
    jobDepartment: Yup.string().max(
      TEXT_200_MAX,
      formatMessage(
        { id: 'maximum.characters.allowed' },
        { limit: TEXT_200_MAX },
      ),
    ),
  })
}

export default ({ initailValue, subscriberId, refetchData }) => {
  const dispatch = useDispatch()
  const { formatMessage } = useIntl()
  const { onEmployerChange, onEmployerReset } = useFormContext()

  const updateEmployInfo = (
    values,
    { resetForm, setSubmitting, setFieldError },
  ) => {
    const info = { type: 'employer', payload: employerMappingToApi(values) }

    effects.apis
      .updateProfileDetailOfSubscriber({ subscriberId, info })
      .then((response) => {
        setSubmitting(false)
        onEmployerReset()
        resetForm({ values })
        refetchData(subscriberId)
        dispatch(
          MessageAlert.showSuccess({
            message: formatMessage({ id: 'message.alert.success' }),
          }),
        )
      })
      .catch((error) => {
        setSubmitting(false)
        const errorCode = error?.response?.data?.details?.code
        if (errorCode === 403) {
          dispatch(
            MessageAlert.showError({
              message: formatMessage({ id: 'error.permission.denied' }),
            }),
          )
        } else if (errorCode === 618) {
          setFieldError(
            'uniqueId',
            formatMessage({ id: 'uniqueId.already.exist' }),
          )
        } else {
          dispatch(
            MessageAlert.showError({
              message: formatMessage({ id: 'message.alert.error' }),
            }),
          )
        }
      })
  }
  return (
    <div className="w-full">
      <Formik
        initialValues={initailValue}
        validationSchema={validationSchema(formatMessage)}
        onSubmit={updateEmployInfo}
      >
        <Form>
          <EmployerInformationForm
            subscriberId={subscriberId}
            onEmployerChange={onEmployerChange}
            onEmployerReset={onEmployerReset}
            refetchData={refetchData}
          />
        </Form>
      </Formik>
    </div>
  )
}
